// extracted by mini-css-extract-plugin
module.exports = {"radio":"FormRadioButton_radio__2u8J2","radio_img":"FormRadioButton_radio_img__1ON2I"};